import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PerformanceTeamPersonalReview } from 'app/library/performance-personal-review/models/performance-team-personal-review.model';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IPerformanceProfilePersonalReviewQuery } from '../interfaces/performance-profile-personal-review.query.interface';
import { PerformanceProfilePersonalReviewCommand } from '../models/performance-profile-personal-review.command.model';
import { PerformanceProfilePersonalReview } from '../models/performance-profile-personal-review.model';

export interface IPerformanceProfilePersonalReviewsAndTotalCount {
    data: IPerformanceProfilePersonalReviewQuery[];
    pagination: {
        number_of_pages: number;
        number_of_results: number;
    };
}

@Injectable()
export class PerformanceProfilePersonalReviewApiService
    extends EntityService<IPerformanceProfilePersonalReviewQuery, PerformanceProfilePersonalReviewCommand>
    implements IEntityApiService<PerformanceProfilePersonalReview>
{
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment, private _translateService: TranslateService) {
        super(http, environment.apiUrl, 'personal-reviews');
    }

    getAll(): Observable<PerformanceProfilePersonalReview[]> {
        return this._getAll().pipe(map((queries) => queries.map((query) => new PerformanceProfilePersonalReview(query))));
    }

    create(entity: PerformanceProfilePersonalReview): Observable<PerformanceProfilePersonalReview> {
        const data = new PerformanceProfilePersonalReviewCommand(entity);

        return this._create(data).pipe(map((query) => new PerformanceProfilePersonalReview(query)));
    }

    read(id: string): Observable<PerformanceProfilePersonalReview> {
        return this._read(id).pipe(
            map((query) => {
                return new PerformanceProfilePersonalReview(query);
            })
        );
    }

    update(entity: PerformanceProfilePersonalReview | PerformanceTeamPersonalReview, teamReviewId?: string): Observable<PerformanceProfilePersonalReview> {
        const data = new PerformanceProfilePersonalReviewCommand(entity, teamReviewId);

        return this.http
            .patch<IPerformanceProfilePersonalReviewQuery>(`${this.apiUrl}/${this.entities}/${entity.id}`, data)
            .pipe(map((query) => new PerformanceProfilePersonalReview(query)));
    }

    delete(id: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/${this.entities}/${id}`);
    }

    getPerformanceProfilePersonalReviews(userId: string, pageSize = 10, pageIndex = 1): Observable<IPerformanceProfilePersonalReviewsAndTotalCount> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString());

        return this.http.get<IPerformanceProfilePersonalReviewsAndTotalCount>(`${this.apiUrl}/users/${userId}/${this.entities}`, { params });
    }
}
